export default __webpack_public_path__ + "static/media/closeYellow.c84ccbe8.svg";